<!-- Component for sorting products by Alphabetical, Price: High to Low, Price: Low to High -->
<template>
	<div class="swiper-no-swiping">
		<Listbox
			as="div"
			v-model="selectedSortOption"
			class="w-full text-left"
			v-slot="{ open }"
		>
			<ListboxButton
				type="button"
				class="swiper-no-swiping group flex cursor-pointer items-center justify-between rounded-md bg-white p-3 focus:outline-hidden"
			>
				<BarsArrowDownIcon
					class="group-hover:text-primary-600 h-8"
					:class="open ? 'text-primary-600' : 'text-slate-400'"
				/>
			</ListboxButton>
			<transition
				leave-active-class="transition ease-in duration-100"
				leave-from-class="opacity-100"
				leave-to-class="opacity-0"
			>
				<ListboxOptions
					class="border-primary-700 absolute left-0 z-50 w-full rounded-md border bg-white font-medium shadow-lg focus:outline-hidden"
				>
					<li class="text-primary-700 p-4">
						{{ t('productControls.sortBy') }}:
					</li>
					<ListboxOption
						v-for="option in sortByOptions"
						:key="option.value"
						:value="option"
						as="template"
						v-slot="{ active, selected }"
						class="last:rounded-b-md"
					>
						<li
							class="cursor-pointer p-4 pr-0 text-slate-900"
							:class="active || selected ? 'bg-slate-100' : ''"
						>
							{{ option.name }}
						</li>
					</ListboxOption>
				</ListboxOptions>
			</transition>
		</Listbox>
	</div>
</template>

<script setup lang="ts">
import type { SortByOption } from '@/components/presentation/productListControls'
import { usePresentationLocale } from '@/i18n'
import {
	Listbox,
	ListboxButton,
	ListboxOption,
	ListboxOptions,
} from '@headlessui/vue'
import { BarsArrowDownIcon } from '@heroicons/vue/24/solid'
import { ref, watch } from 'vue'

const { t } = usePresentationLocale()

const sortByOptions: SortByOption[] = [
	{
		name: t('productControls.alphabetical'),
		value: 'alphabetical',
	},
	{
		name: t('productControls.priceHighToLow'),
		value: 'price-high-to-low',
	},
	{
		name: t('productControls.priceLowToHigh'),
		value: 'price-low-to-high',
	},
]

const emit = defineEmits<{
	'sort-by': [option: SortByOption]
}>()

const selectedSortOption = ref(sortByOptions[0])

watch(selectedSortOption, (option) => {
	if (!option) return
	emit('sort-by', option)
})
</script>
